export default "__VITE_ASSET__Dq5OH6cE__"